module.exports = {"210321001":"八角台街道","210321002":"台东街道","210321101":"西佛镇","210321102":"新开河镇","210321103":"黄沙坨镇","210321104":"高力房镇","210321105":"桑林镇","210321106":"富家镇","210321107":"达牛镇","210321109":"韭菜台镇","210321110":"新台镇","210321111":"桓洞镇","210321400":"新华农场","210321401":"洪家农牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210321.json
// module id = 617
// module chunks = 0